import useCanCall from '@inbox-demo-nx/hooks-use-can-call';
import { RowStack } from '@inbox-demo-nx/ui';
import { isChannelVerified } from '@inbox-demo-nx/utils-chat-common';
import { Text, View } from 'dripsy';
import SendBird from 'sendbird';

const ChannelSubtitle = ({ channel }: { channel: SendBird.GroupChannel }) => {
  const canCall = useCanCall(channel);

  if (isChannelVerified(channel)) {
    return null;
  }

  if (channel.members.length > 2) {
    return (
      <Text
        sx={{
          fontSize: 'xsmall',
          color: 'navigationHeaderTextColor',
        }}
      >
        {channel.members.length} people
      </Text>
    );
  }

  if (!canCall) {
    return null;
  }

  return (
    <RowStack>
      <View
        sx={{
          mr: 4,
          width: 8,
          height: 8,
          borderRadius: 4,
          backgroundColor: 'onlineColor',
        }}
      />
      <Text sx={{ color: 'navigationHeaderTextColor', fontSize: 'xsmall' }}>
        Online now
      </Text>
    </RowStack>
  );
};

export default ChannelSubtitle;
